import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from '../../../components/loading';
import MyGroupsComponent from '../../components/my-groups/index';
import { fetchUserPurchases } from '../../actions/index';
import { getCurrentUser, getCurrentUserPurchases } from '../../selectors/user-selector';

class MyGroups extends Component {
  state = {
    purchasesLoaded: null,
  };

  componentWillMount() {
    const { user, authentication } = this.props;
    this.setState({ loadingPurchases: true });
    this.props.fetchUserPurchases(user, authentication)
      .then(() => this.setState({ purchasesLoaded: true }));
  }

  render() {
    const { purchases } = this.props;
    if (!this.state.purchasesLoaded) return <Loading />;

    return (
      <MyGroupsComponent
        purchases={purchases}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const user = getCurrentUser(state);
  const purchases = getCurrentUserPurchases(state);

  return {
    user,
    purchases,
    authentication: state.session.authentication,
  };
};

const mapDispatchToProps = {
  fetchUserPurchases,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyGroups);



// WEBPACK FOOTER //
// ./src/desktop/containers/my-groups/index.container.js